import script from "./StudyForm.vue?vue&type=script&setup=true&lang=js"
export * from "./StudyForm.vue?vue&type=script&setup=true&lang=js"

import "./StudyForm.vue?vue&type=style&index=0&id=d6ab36f8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d6ab36f8"]])

export default __exports__